import * as types from "../actions/types";

const initialState = {
  list: [],
  loading: false,
  item: {}
};

export default function new_school_year(state = initialState, action) {
  switch (action.type) {

    case types.GET_NEW_SCHOOL_YEAR:
      return {
        ...state,
        listNSE: action.payload
      };
      case types.SET_EXAM_CITY_LIST_LOADING:
        return {
          ...state,
          loading: action.payload
        };
      case types.SET_EXAM_CITY_BY_ID:
        return {
          ...state,
          item: action.payload
        };
    default:
      return state;
  }
}